import styled from 'styled-components';

export const ContainerHeader = styled.div`
  display: flex;
  color: #74777a;
  background-color: #fafafa;
  font-weight: bold;
  align-items: center;
`;

export const ContainerRow = styled.div`
  display: flex;
  border-bottom: 1px solid #dee2e6;
  color: #74777a;
  background-color: #fff;
  align-items: center;
`;

export const ContainerFooter = styled.div`
  display: flex;
  color: #74777a;
  align-items: center;
  justify-content: space-between;
`;

interface IColumnProps {
  width?: string;
  padding?: string;
  textAlign?: string;
  maxHeight?: string;
}

export const ColumnHeader = styled.div<IColumnProps>`
  width: ${props => props.width || '100%'};
  max-width: ${props => props.width || '100%'};
  min-width: ${props => props.width || '100%'};
  padding: ${props => props.padding || '6px'};
  text-align: ${props => props.textAlign || 'left'};
  border-bottom: 1px solid #dee2e6;
`;

export const ColumnRow = styled.div<IColumnProps>`
  width: ${props => props.width || '100%'};
  max-width: ${props => props.width || '100%'};
  min-width: ${props => props.width || '100%'};
  padding: ${props => props.padding || '6px'};
  overflow-wrap: anywhere;
  text-align: ${props => props.textAlign || 'left'};
`;

interface IColumnRowValueWithMaxHeightProps {
    maxHeight: string;
}

export const ColumnRowValueWithMaxHeight = styled.div<IColumnRowValueWithMaxHeightProps>`
  max-height: ${props => props.maxHeight};
  overflow-x: auto;
`;

export const ColumnRowValueWithoutMaxHeight = styled.div`
`;